module.exports = __webpack_public_path__ + "static/media/sucess.3e4c94fc.png";